// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qp-0";